module.exports = __webpack_public_path__ + "static/resume-2cc8492faa8db801d0c1cea8e60ab2be.pdf";